import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type Banner = {
  banner_id?: number; // 배너 idx
  shop_information_id?: number; // 쇼/브/매/지 idx
  banner_name?: string; // 배너명
  is_show?: string; // 노출여부
  start_date?: number; // 노출 시작일
  end_date?: number; // 노출 종료일
  banner_url?: string; // 배너 파일 url
  banner_type?: string; // 배너 타입
  render_url?: string; // 랜딩 url
  is_new_window?: string; // 새창 여부
  show_channel?: { [key: string]: string | number }; // 노출 채널
  rating_show?: { [key: string]: string | number }; // 회원 등급 노출 설정
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Banner
   * --
   */
  getBanners: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_BANNER, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Banner
   * --
   */
  getBanner: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_BANNER, { banner_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Banner
   * --
   */
  createBanner: async (body: Banner) => {
    try {
      const res = await $http.post(APIConstant.CREATE_BANNER, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Banner
   * --
   */
  updateBanner: async (body: Banner) => {
    try {
      const { banner_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_BANNER, {
        banner_id: banner_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Banner
   * --
   */
  deleteBanner: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_BANNER, {
        banner_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Banner
   * --
   */
  upsertBanner: async (body: Banner[]) => {
    try {
      const res = await $http.bulk(APIConstant.BULK_UPSERT_BANNER, body, 'PUT');

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
